import {
    CHECK_ACCOUNT_BY_PHONE,
    CHECK_ACCOUNT_BY_PHONE_ERROR,
    CHECK_ACCOUNT_BY_PHONE_INITIAL,
    CHECK_ACCOUNT_BY_PHONE_SUCCESS,
    CheckAccountByPhoneAction,
    CheckAccountByPhoneState,
} from '../_types/checkAccountByPhone';

const initialState: CheckAccountByPhoneState = {
    data: null,
    loading: false,
    error: null,
};

export default (state = initialState, action: CheckAccountByPhoneAction): CheckAccountByPhoneState => {
    switch (action.type) {
        case CHECK_ACCOUNT_BY_PHONE:
            return {
                ...initialState,
                loading: true,
            };
        case CHECK_ACCOUNT_BY_PHONE_SUCCESS:
            return {
                ...initialState,
                data: action.payload,
            };
        case CHECK_ACCOUNT_BY_PHONE_ERROR:
            return {
                ...state,
                error: action.payload,
                loading: false,
            };
        case CHECK_ACCOUNT_BY_PHONE_INITIAL:
            return initialState;
        default:
            return state;
    }
};
